import type { Context } from '@/types'
import { matchKey } from '@/utils/matchKey.utils'
import {
  collectOptionCandidates,
  resolveLocalizedOptionLabel,
} from './localizedOptionLabel'

type CategoryOptions = NonNullable<Context['propertyOptions']>['category']

export const createLocalizedCatalogNodeText = ({
  value,
  categoryOptions,
  categoryOptionsByID,
  type,
  locale,
  fallbackValue,
  categoryRefData,
}: {
  value: string | undefined
  categoryOptions: CategoryOptions | undefined
  categoryOptionsByID: Context['optionsByID']['category'] | undefined
  type: 'lot' | 'category'
  locale: string
  fallbackValue?: string
  categoryRefData?: NonNullable<Context['refDataByKey']>['category']
}): string => {
  try {
    if (!value) return fallbackValue || ''

    const hasOptions =
      Array.isArray(categoryOptions) && categoryOptions.length > 0
    const matchedProperty = hasOptions
      ? matchKey(value, categoryOptions, categoryOptionsByID)
      : undefined
    const property =
      matchedProperty?.review === true ? undefined : matchedProperty
    const label = resolveLocalizedOptionLabel({
      candidates: collectOptionCandidates(value),
      locale,
      lookupSources: {
        references: categoryOptions,
        optionsByID: categoryOptionsByID,
        refData: categoryRefData,
      },
      fallbackValue,
    })

    let index = ''
    if (type === 'lot') {
      index = property?.value?.toString() || ''
    } else if (type === 'category') {
      const categoryIndex = Number(property?.value?.toString().split('-')?.[0])
      index = !isNaN(categoryIndex) ? categoryIndex.toString() : ''
    }

    return (index ? `${index}. ${label}` : label || '').toLocaleUpperCase()
  } catch (error) {
    console.warn('Error in createLocalizedCatalogNodeText:', error, {
      value,
      categoryOptions,
      type,
      fallbackValue,
      categoryRefData,
    })
    return fallbackValue || ''
  }
}
